export default from './PageViewFlipbookNew';